// TARGET Design System — fade-up on scroll. Ported from HomePage.jsx's .reveal
// classes, swapping React's mount-time toggle for an IntersectionObserver.
//
// Elements marked [data-reveal] are VISIBLE by default. This script opts them
// into the animation by adding .reveal-ready, then reveals them with
// .reveal-in as they scroll into view. If the script never runs, content just
// shows — it can never leave the page blank.
(function () {
  var els = document.querySelectorAll('[data-reveal]');
  if (!els.length) return;

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduced || !('IntersectionObserver' in window)) return;

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('reveal-in');
        observer.unobserve(entry.target);
      });
    },
    { threshold: 0.12 }
  );

  els.forEach(function (el) {
    el.classList.add('reveal-ready');
    // Stagger siblings so a row of cards cascades instead of snapping in together.
    var idx = el.parentElement ? Array.prototype.indexOf.call(el.parentElement.children, el) : 0;
    el.style.setProperty('--reveal-delay', Math.min(idx, 5) * 60 + 'ms');
    observer.observe(el);
  });
})();
